import { UserType } from "@istari/istari-client";

import type { InternalUserType } from "~/api/user/user";
import { resolveUserDisplayName } from "~/user/utils/format-user-name";
import { isRegistryAgentId } from "~/user/utils/legacy-zitadel-agent";

export function getAgentFallbackId(user: InternalUserType | null | undefined): string | null {
  if (!user || user.userType !== UserType.Agent || resolveUserDisplayName(user)) return null;
  const providerUserId = user.providerUserId;
  return isRegistryAgentId(providerUserId) ? providerUserId : null;
}
